export const classes = {
  button:
    'flex items-center gap-1.5 rounded-full border border-brand-accent/40 bg-brand-accent/10 px-3 py-1.5 text-sm font-bold text-brand-accent transition-colors hover:bg-brand-accent/15 dark:border-brand-accent-dark/40 dark:bg-brand-accent-dark/10 dark:text-brand-accent-dark dark:hover:bg-brand-accent-dark/15',
};
